module.exports = __webpack_public_path__ + "img/image6.9b978adf.png";